module.exports = __webpack_public_path__ + "a4acc68fe1334b3eb010b5c8f44e24e5.svg";